import DoublesMatches from "./DoublesMatchesList/DoublesMatches";
import DoublesPointSelection from "./PointSelection/DoublesPointSelection";
import DoublesVideoPlayer from "./VideoPlayer/DoublesVideoPlayer";
import { useSelector } from "react-redux";
import { selectUser, selectIsAllowedDoublesPlayer } from "../auth/authSlice";
import NotAuthorizedPage from "../../pages/notAuthorizedPage";
import Spinner from "../../UI/Spinner";

const DoublesMatchesPage = () => {
  const user = useSelector(selectUser);
  const isAllowedDoublesPlayer = useSelector(selectIsAllowedDoublesPlayer);


  if (!user || isAllowedDoublesPlayer == null) return <Spinner />;
  else if (isAllowedDoublesPlayer === false) return <NotAuthorizedPage />;

  return (
    <div className="row">
      <div className="col-9 mb-3 pr-0">
        <DoublesMatches />
        <DoublesVideoPlayer />
      </div>
      <div className="col-3 mb-3 pr-3">
        <DoublesPointSelection />
      </div>
    </div>
  );
};

export default DoublesMatchesPage;
